module.exports = __webpack_public_path__ + "img/product-admin.62655712.svg";